export default __webpack_public_path__ + "static/media/image-cushion-r-w.04df71e5.webp";